import { styled } from 'styled-components';
import {
  textTinySemiBold,
  textMediumSemiBold,
  textMediumNormal,
} from '@hud/web-components/DesignSystem/Typography';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  width: 100%;
  justify-content: center;

  .main {
    display: flex;
    flex-direction: column;
    flex: 1;
    max-width: 1440px;
    overflow: hidden;
    padding: 0 var(--space-300);
  }

  // this allows for horizontal end-to-end lines
  @container (min-width: 1600px) {
    .main {
      overflow: visible;
    }
  }

  .overviewSidebar {
    max-width: 270px;
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: var(--space-300);
    border-left: 1px solid transparent;
    list-style-type: none;
    margin: 0;
    padding: 0 var(--space-150);

    &:before {
      content: '';
      position: absolute;
      left: 1px;
      top: -100px;
      width: 1px;
      height: calc(100% + 100px);
      border-left: 1px solid var(--border-color-default);
    }
  }

  section {
    padding: var(--space-525) 0;
    position: relative;
    bottom: 0;

    &:before {
      content: '';
      position: absolute;
      bottom: 0;
      right: calc(var(--space-400) * -1 + 7px);
      width: 200vw;
      height: 1px;
      background-color: var(--border-color-default);
    }

    &:first-child {
      padding-top: 0;
    }

    &:last-child:before {
      display: none;
    }
  }

  h3 {
    display: flex;
    align-items: center;
    gap: var(--space-200);
    ${textMediumSemiBold};
    color: var(--text-standard-primary);

    .iconContainer {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      background: var(--black-500);
      border-radius: 5px;

      box-shadow: 0 0 10px rgba(255, 255, 255, 0.2);

      svg path {
        stroke: var(--text-primary);
      }
    }

    .secondary {
      color: var(--black-700);
      ${textTinySemiBold};
      padding-left: var(--space-50);
    }
  }

  .tables {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--space-300);
  }

  .tableContainer {
    .title {
      display: inline-flex;
      position: relative;
      padding: var(--space-100) 0;
      margin-bottom: var(--space-100);
      ${textMediumNormal};
      color: var(--text-standard-primary);
      gap: var(--space-100);
      align-items: center;
    }

    &:nth-child(2n) {
      width: 100%;
    }
  }
`;
